document.addEventListener('DOMContentLoaded', function() {
    const slides = document.querySelectorAll('.testimonial-slide');
    const indicatorsContainer = document.querySelector('.testimonial-indicators');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');
    let currentSlide = 0;
    
    // Create indicators based on number of slides
    function createIndicators() {
      indicatorsContainer.innerHTML = ''; // Clear existing indicators
      
      slides.forEach((slide, index) => {
        const indicator = document.createElement('button');
        indicator.className = 'indicator';
        indicator.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
        
        if (index === currentSlide) {
          indicator.classList.add('show-tab');
        }
        
        indicator.addEventListener('click', function() {
          currentSlide = index;
          showSlide(currentSlide);
        });
        
        indicatorsContainer.appendChild(indicator);
      });
    }
    
    // Show initial slide and create indicators
    showSlide(currentSlide);
    createIndicators();
    
    // Next button click
    nextBtn.addEventListener('click', function() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
      updateIndicators();
    });
    
    // Previous button click
    prevBtn.addEventListener('click', function() {
      currentSlide = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(currentSlide);
      updateIndicators();
    });
    
    // Update indicator states
    function updateIndicators() {
      const indicators = document.querySelectorAll('.indicator');
      indicators.forEach((indicator, index) => {
        if (index === currentSlide) {
          indicator.classList.add('show-tab');
        } else {
          indicator.classList.remove('show-tab');
        }
      });
    }
    
    function showSlide(index) {
      // Hide all slides
      slides.forEach(slide => {
        slide.classList.remove('show-tab');
      });
      
      // Show current slide
      slides[index].classList.add('show-tab');
      
      // Update indicators
      updateIndicators();
    }
    
    // Auto-rotate (optional)
    // setInterval(() => {
    //   currentSlide = (currentSlide + 1) % slides.length;
    //   showSlide(currentSlide);
    //   updateIndicators();
    // }, 5000);
  });